import { MessageSenderType } from '@estercare/ester-shared'
import { CaseResponse } from '../api/ester-b2b-api/private/case/types'

export const isCaseUnread = (c: CaseResponse) =>
  !!c.lastMessage && !c.lastMessage.isRead && c.lastMessage.sender === MessageSenderType.ESTERCARE

export const getSenderTitle = (senderType: MessageSenderType, firstName?: string) => {
  if (senderType === MessageSenderType.ESTERCARE) return 'EsterCare'
  else if (firstName) return `${firstName}`
  else return null
}
